import Pill from 'components/Pill';
import Table from 'components/Table/TableFunctional';
import TooltipWrapper from 'components/Tooltip';
import Truncator from 'components/Truncator';
import {FC} from 'react';
import {useBackend} from 'state/backend';
import {twMerge} from 'tailwind-merge';
import {c} from 'ttag';

import DocumentTypePills from '../../DocumentTypePills';
import {FavouriteTemplatesBackendData} from '../../types';

const Section: FC = () => {
    const {
        data: {availableDocumentTypes, favouriteTemplates},
    } = useBackend<FavouriteTemplatesBackendData>();

    return (
        <div className="mt-4 flex min-w-[48rem] flex-col gap-y-3">
            <Table aria-label="favorite-templates" classNameTable="table-fixed">
                <Table.Header>
                    <Table.Column className="w-20">
                        <div className="pl-2">{c('component').t`Order`}</div>
                    </Table.Column>
                    <Table.Column className="w-56">
                        {c('component').t`Document Type(s)`}
                    </Table.Column>
                    <Table.Column>
                        {c('component').t`Template Name`}
                    </Table.Column>
                </Table.Header>
                {favouriteTemplates.length > 0 ? (
                    <Table.Body items={favouriteTemplates}>
                        {favouriteTemplates.map((template, index) => (
                            <Table.Row
                                aria-label={`template-row-${template.id}`}
                                key={template.id}
                            >
                                <Table.Cell
                                    className={twMerge(
                                        (template.isArchived ||
                                            template.isUnavailable) &&
                                            'opacity-40',
                                    )}
                                    preventPointerEvents={true}
                                >
                                    <div className="pl-2">{index + 1}</div>
                                </Table.Cell>
                                <Table.Cell preventPointerEvents={true}>
                                    <DocumentTypePills
                                        availableDocumentTypes={
                                            availableDocumentTypes
                                        }
                                        documentTypeDisplayNames={
                                            template.documentTypeDisplayNames
                                        }
                                    />
                                </Table.Cell>
                                <Table.Cell
                                    className="flex"
                                    preventPointerEvents={true}
                                >
                                    <Truncator
                                        className={twMerge(
                                            (template.isArchived ||
                                                template.isUnavailable) &&
                                                'opacity-40',
                                            'max-w-md',
                                        )}
                                        text={template.templateDisplayName}
                                    />
                                    {template.isArchived && (
                                        <TooltipWrapper
                                            message={c('component')
                                                .t`Archived Template, will not appear in Document Template picker`}
                                        >
                                            <Pill
                                                className="ml-2"
                                                color="grey_dark"
                                                label={c('component')
                                                    .t`Archived`}
                                            />
                                        </TooltipWrapper>
                                    )}
                                    {template.isUnavailable && (
                                        <TooltipWrapper
                                            message={c('component')
                                                .t`Unavailable Template, will not appear in Document Template picker`}
                                        >
                                            <Pill
                                                className="ml-2"
                                                color="grey_dark"
                                                label={c('component')
                                                    .t`Unavailable`}
                                            />
                                        </TooltipWrapper>
                                    )}
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                ) : (
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>
                                <div className="w-16 whitespace-nowrap text-grey-600">
                                    {c('component')
                                        .t`No Favorite Templates set.`}
                                </div>
                            </Table.Cell>
                            <Table.Cell>{null}</Table.Cell>
                            <Table.Cell>{null}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                )}
            </Table>
        </div>
    );
};

export default Section;
